/**
 * Stub pour class-transformer - non utilisé dans le frontend
 * Ce fichier existe uniquement pour éviter les erreurs de résolution dans Vite
 */

// Les décorateurs sont supprimés à la compilation TypeScript de toute façon
const StubDecorator = (...args: any[]) => (target: any, key: any) => {};

export const Transform = StubDecorator;
export const Type = StubDecorator;
export const Expose = StubDecorator;
export const Exclude = StubDecorator;

